// Currently, WCA allow up to 4 rounds for each event.
export const MAX_WCA_ROUNDS = 4;

export const MBLD_MIN = 2;
export const MBLD_DEFAULT = 35;
